var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen",
    clipPath: "url(#clip0_459_3201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.16659 1.83323L6.10939 2.77604M1 6.99982L1.01582 6.8891C1.07179 6.49731 1.09977 6.30141 1.16343 6.11852C1.21992 5.95623 1.29708 5.8019 1.39302 5.65934C1.50114 5.49868 1.64106 5.35875 1.92091 5.0789L5.80358 1.19624C6.06393 0.935889 6.48604 0.935889 6.74639 1.19624C7.00674 1.45659 7.00674 1.8787 6.74639 2.13905L2.79248 6.09295C2.5386 6.34684 2.41166 6.47378 2.26707 6.57473C2.13873 6.66433 2.00031 6.73856 1.85466 6.79589C1.69057 6.86048 1.51458 6.89599 1.16264 6.967L1 6.99982Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_3201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/penIcon.d8ba21370c2767c8564946e5cd6e452d.svg";
export { ForwardRef as ReactComponent };